import type { TrigKey } from './keys';

export const nl: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Wiskunde · Trigonometrie',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parameters',
  'panel.scene': 'Kies een experiment',
  'experiment.right-triangle.label': 'Rechthoekige driehoek',
  'experiment.unit-circle.label': 'Eenheidscirkel',
  'experiment.wave-studio.label': 'Golfstudio',
  'experiment.identity-playground.label': 'Identiteiten',
  'experiment.triangle-solver.label': 'Driehoek-oplosser',
  'experiment.circular-polar.label': 'Cirkel & polair',
  'hint.line1': 'Sleep punten, beweeg schuifregelaars.',
  'hint.line2': 'Leerstof leeft in de meetkunde, niet in tekst.',
  'rt.angle.a': 'Hoek A',
  'rt.angle.b': 'Hoek B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radialen',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Vang aan 30°/45°/60°',
  'uc.units': 'Eenheden',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Toon ASTC',
  'uc.snap.common': 'Vang aan veelgebruikte hoeken',
  'uc.angle.value': '∠',
  'uc.units.deg': 'graden',
  'uc.units.rad': 'rad',
  'uc.units.both': 'graden+rad',
  'ws.fn': 'Functie',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Frequentie',
  'ws.phase': 'C — Faseverschuiving',
  'ws.shift': 'D — Verticale verschuiving',
  'ws.rform.toggle': 'R-vorm afleiding',
  'ws.rform.a': 'a (sin-coëf.)',
  'ws.rform.b': 'b (cos-coëf.)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Reset',
  'ws.base': 'Toon basiscurve',
  'ip.id.pythagorean': 'Pythagoreïsch',
  'ip.id.reciprocal': 'Reciproke',
  'ip.id.quotient': 'Quotiënt',
  'ip.id.sum': 'Som',
  'ip.id.difference': 'Verschil',
  'ip.id.double': 'Dubbele hoek',
  'ip.id.half': 'Halve hoek',
  'ip.play': 'Afspelen',
  'ip.pause': 'Pauze',
  'ip.step': 'Stap',
  'ip.reset': 'Reset',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'In v2 — dit bewijs vraagt een uitgebreidere constructie.',
  'ts.area': 'Oppervlakte',
  'ts.sineRule': 'Sinusregel',
  'ts.cosineRule': 'Cosinusregel',
  'ts.ambiguous.toggle': 'Geest-driehoek bij dubbelzinnigheid',
  'ts.reset': 'Reset naar gelijkzijdig',
  'ts.snap.integers': 'Vang aan gehelen',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Zijden',
  'ts.section.angles': 'Hoeken',
  'ts.section.sineRule': 'Sinusregel',
  'ts.section.cosineRule': 'Cosinusregel',
  'ts.section.area': 'Oppervlakte',
  'cp.omega': 'Hoeksnelheid',
  'cp.plot.y': 'Plot y (sin)',
  'cp.plot.x': 'Plot x (cos)',
  'cp.polar.label': 'Polaire figuur',
  'cp.polar.circle': 'Cirkel (r = 1)',
  'cp.polar.rose': 'Roos (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioïde (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Kleine-hoek benadering (sin x ≈ x)',
  'cp.play': 'Afspelen',
  'cp.pause': 'Pauze',
  'cp.reset': 'Reset',
  'cp.step': 'Stap π/12',
};
